<template>
  <div v-show="contentShow">
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240)"
      :title="$t('camReport.camReport')"
      sub-title=""
    />
    <a-card class="content_card" :bordered="false">
      <a-form
        name="camReport"
        :model="formState"
        autocomplete="off"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        ref="formRef"
        :rules="rules"
      >
        <a-row :gutter="[40, 24]">
          <a-col :span="12">
            <a-form-item name="Product" :label="$t('camReport.product')">
              <a-select
                ref="select"
                v-model:value="formState.Product"
                :options="options"
                @change="handleProductChange"
                :disabled="true"
              ></a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item name="Version" :label="$t('camReport.version')">
              <a-input
                v-model:value="formState.Version"
                :placeholder="$t('camReport.versionin')"
                :disabled="true"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item name="UserName" :label="$t('camReport.name')">
              <a-input
                v-model:value="formState.UserName"
                :placeholder="$t('camReport.namein')"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item name="Phone" :label="$t('camReport.phone')">
              <a-input
                v-model:value="formState.Phone"
                :placeholder="$t('camReport.phonein')"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item name="Title" :label="$t('camReport.title')">
              <a-input
                v-model:value="formState.Title"
                :placeholder="$t('camReport.titlein')"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item name="ExProcessingTime" :label="$t('camReport.exTime')">
              <a-date-picker
                v-model:value="selectTime"
                show-time
                placeholder="$t('camReport.exTimein')"
                :disabled-date="disabledDate"
                :allow-clear="false"
                @ok="onOk"
                :showNow="false"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('camReport.step')" name="HtmlContent">
              <vue-ueditor-wrap
                v-model="formState.HtmlContent"
                :config="editorConfig"
                :forceInit="true"
              ></vue-ueditor-wrap
            ></a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              v-if="formState.Product == '1'"
              :label="$t('userReport.bnt')"
              name="BntFile"
              :rules="[
                {
                  required: true,
                  message: t('userReport.bntin'),
                  trigger: 'blur',
                },
              ]"
            >
              <a-upload
                v-model:file-list="fileListBnt"
                name="fileBnt"
                :customRequest="customRequestBnt"
                :before-upload="beforeBntUpload"
                :maxCount="1"
                accept=".bnt"
                :showUploadList="true"
              >
                <a-button :loading="uploadLoadingBnt">
                  <upload-outlined></upload-outlined>
                  {{ $t("userReport.import") }}
                </a-button>
              </a-upload>
            </a-form-item>
            <a-form-item
              v-if="formState.Product == '0'"
              :label="$t('userReport.bnn')"
              name="BntFile"
              :rules="[
                {
                  required: true,
                  message: t('userReport.bnnin'),
                  trigger: 'blur',
                },
              ]"
            >
              <a-upload
                v-model:file-list="fileListBnt"
                name="fileBnt"
                :customRequest="customRequestBnt"
                :before-upload="beforeBntUpload"
                :maxCount="1"
                accept=".bnn,.bnd"
                :showUploadList="true"
              >
                <a-button :loading="uploadLoadingBnt">
                  <upload-outlined></upload-outlined>
                  {{ $t("userReport.import") }}
                </a-button>
              </a-upload>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="$t('userReport.other')"
              name="OtherFile"
              v-if="formState.Product == '1'"
            >
              <a-upload
                v-model:file-list="fileListOther"
                name="fileOther"
                :customRequest="customRequestOther"
                :before-upload="beforeOtherUpload"
                :maxCount="1"
                accept=".igs,.iges,.stp,.step"
                :showUploadList="true"
              >
                <a-button :loading="uploadLoadingOther">
                  <upload-outlined></upload-outlined>
                  {{ $t("userReport.import") }}
                </a-button>
              </a-upload>
            </a-form-item>
            <a-form-item
              :label="$t('userReport.other2')"
              name="OtherFile"
              v-if="formState.Product == '0'"
            >
              <a-upload
                v-model:file-list="fileListOther"
                name="fileOther"
                :customRequest="customRequestOther"
                :before-upload="beforeOtherUpload"
                :maxCount="1"
                accept=".dxf,.dwg"
                :showUploadList="true"
              >
                <a-button :loading="uploadLoadingOther">
                  <upload-outlined></upload-outlined>
                  {{ $t("userReport.import") }}
                </a-button>
              </a-upload>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-button
              type="primary"
              :loading="submitLoading"
              @click="onSubmit"
              style="margin-left: 100px"
              >{{ $t("camReport.submit") }}</a-button
            >
          </a-col>
        </a-row>
      </a-form>
    </a-card>
  </div>
</template>

<script setup>
/**
 * CreationTime：2024.6.14 Fir
 * LastEditingTime：2024.6.14 Fir
 * Written by ShiYechen
 */
import { ref, computed, h } from "vue";
import axios from "axios";
import { message, Modal } from "ant-design-vue";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";
import { UploadOutlined } from "@ant-design/icons-vue";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

/**主体内容 */
const contentShow = ref(false);
const labelCol = { style: { width: "100px" } };
const wrapperCol = { span: 20 };
const formRef = ref();
const formState = ref({});
const editorConfig = ref({
  UEDITOR_HOME_URL: "/UEditor/", // 访问 UEditor 静态资源的根路径，可参考常见问题1
  serverUrl: "https://apicloud.bodor.com/UEditor/upload",
});
const BntFileName = ref("");
const fileListBnt = ref([]);
const uploadLoadingBnt = ref(false);

const OtherFileName = ref("");
const fileListOther = ref([]);
const uploadLoadingOther = ref(false);

const submitLoading = ref(false);
const i18n = useI18n();
/**Form 产品选择器 */
const select = ref(null);
const options = [
  { value: "0", label: "Bodor Nest" },
  { value: "1", label: "Bodor Nest Tube" },
  { value: "2", label: "Bodor Hub" },
  { value: "3", label: "Bodor MES" },
  { value: "4", label: "Bodor Thinker 5.0" },
  { value: "5", label: "Bodor Thinker Tube 5.0" },
];
/**From时间选择器 */
const selectTime = ref();
const assetsUrl = require("@/assets/img/software/appicon.png");

/**主函数入口 */
init();

function init() {
  //首先从网址中获取必要的参数，获取不到则自动返回首页
  formState.value.Product = route.query.Product;
  formState.value.Version = route.query.Version;
  let loacl = localStorage.getItem("lang");
  let lang = route.query.lang;
  if (lang == "zh") {
    if (loacl != "zh") {
      i18n.locale = "zh";
      localStorage.setItem("lang", "zh");
      loacl = "zh";
      location.reload();
    }
  } else if (lang && loacl != "en") {
    i18n.locale = "en";
    localStorage.setItem("lang", "en");
    loacl = "en";
    location.reload();
  }
  if (!(formState.value.Product && formState.value.Version)) {
    Modal.error({
      title: t("camReport.error"),
      content: h("div", {}, [h("p", t("camReport.errorin"))]),
      onOk() {
        router.push("/");
      },
    });
  } else {
    contentShow.value = true;
  }
  selectTime.value = dayjs().add(7, "day");
}

// 验证并提交数据
function onSubmit() {
  const formattedDate = utcToCST(new Date(selectTime.value.toISOString()));
  formRef.value
    .validate()
    .then(() => {
      submitLoading.value = true;
      let pararm = JSON.parse(JSON.stringify(formState.value));

      axios
        .post("api/Cam/ProblemFeedbackSave", {
          Id: "",
          Product: pararm.Product,
          Version: pararm.Version,
          ExProcessingTime: formattedDate,
          UserName: pararm.UserName ? pararm.UserName : "",
          Phone: pararm.Phone ? pararm.Phone : "",
          Title: pararm.Title,
          HtmlContent: pararm.HtmlContent,
          BntFile: pararm.BntFile,
          OtherFile: pararm.OtherFile,
        })
        .then((response) => {
          if (response.data.code != 200) {
            message.error(response.data.info);
          } else {
            Modal.success({
              title: t("camReport.success"),
              width: "600px",
              content: h("div", {}, [
                h("p", t("camReport.successin")),
                h("p", [
                  h("span", t("camReport.registerUrl")),
                  h(
                    "a",
                    { href: "https://icloud.bodor.com/", style: { color: "#1677ff" } },
                    "https://cloud.bodor.com/"
                  ),
                ]),
                h("p", t("camReport.app")),
                h("img", {
                  src: assetsUrl,
                  width: "150",
                  height: "150",
                }),
              ]),
              onOk() {
                Modal.destroyAll();
              },
            });
          }
        })
        .finally(() => {
          submitLoading.value = false;
          formRef.value.resetFields();
          fileListBnt.value = [];
          fileListOther.value = [];
        });
    })
    .catch((error) => {});
}

//上传前验证
async function beforeBntUpload(file) {
  const type = file.name.split(".").pop();
  const fileAccept =
    formState.value.Product == "1" ? ["bnt", "BNT"] : ["bnn", "BNN", "bnd", "BND"]; // 支持的文件类型

  if (!fileAccept.includes(type)) {
    message.error(t("userReport.nosupport"));
    setTimeout(function () {
      fileListBnt.value = [];
    }, 0);

    return false;
  } else {
    return true;
  }
}

function customRequestBnt(file) {
  const form = new FormData();
  form.append("file", file.file);
  uploadLoadingBnt.value = true;
  // 用自己的接口
  axios
    .post("api/Cam/UploadBntFile", form, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      uploadLoadingBnt.value = false;
      if (response.data.code != 200) {
        message.error(response.data.info);
      } else {
        message.success(t("camReport.uploadsucc"));
        formState.value.BntFile = response.data.ReturnData.FileUrl;
        fileListBnt.value = [];
        fileListBnt.value.push({
          uid: "1",
          name: response.data.ReturnData.FileName,
          status: "done",
          url: "https://apicloud.bodor.com" + response.data.ReturnData.FileUrl,
        });
      }
    })
    .catch(() => {
      fileListBnt.value = [];
      message.error(t("camReport.uploaderror"));
    });
}

//上传前验证
async function beforeOtherUpload(file) {
  const type = file.name.split(".").pop();
  const fileAccept =
    formState.value.Product == "1"
      ? ["igs", "iges", "stp", "step", "IGS", "IGES", "STP", "STEP"]
      : ["dxf", "DXF", "dwg", "DWG"]; // 支持的文件类型

  if (!fileAccept.includes(type)) {
    message.error(t("userReport.nosupport"));
    setTimeout(function () {
      fileListOther.value = [];
    }, 0);

    return false;
  } else {
    return true;
  }
}

/**时间选择器禁用今天之后的日期 */
function disabledDate(current) {
  // Can not select days after today and today
  return current && current < dayjs().endOf("day");
}

/**时间选择器禁用打开选择器之后的时分秒 */
function disabledDateTime(current) {
  return {
    disabledHours: () => range(0, 24).splice(current.$H + 1),
    disabledMinutes: () => range(0, 60).splice(current.$m + 1),
    disabledSeconds: () => range(0, 60).splice(current.$s + 1),
  };
}

/**时间选择器禁用函数辅助方法 */
function range(start, end) {
  const result = [];
  for (let i = start; i < end; i++) {
    result.push(i);
  }
  return result;
}

function customRequestOther(file) {
  const form = new FormData();
  form.append("file", file.file);
  uploadLoadingOther.value = true;
  // 用自己的接口
  axios
    .post("api/Cam/UploadIgsAndStpFile", form, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      uploadLoadingOther.value = false;
      if (response.data.code != 200) {
        message.error(response.data.info);
      } else {
        message.success(t("camReport.uploadsucc"));
        formState.value.OtherFile = response.data.ReturnData.FileUrl;
        fileListOther.value = [];
        fileListOther.value.push({
          uid: "2",
          name: response.data.ReturnData.FileName,
          status: "done",
          url: "https://apicloud.bodor.com" + response.data.ReturnData.FileUrl,
        });
      }
    })
    .catch(() => {
      fileListOther.value = [];
      message.error(t("camReport.uploaderror"));
    });
}

/**校验联系方式是否为手机号或者邮箱 */
async function validatePhone(_rule, value) {
  if (!value) {
    return Promise.reject(t("camReport.phonein"));
  }
  const emailVer = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const phoneVer = /^(\+|\d{1,3})\s?(\d{1,4})?\s?\(?\d{1,4}\)?\s?\d{1,4}\s?\-?\d{1,9}$/;

  if (value.match(emailVer) || value.match(phoneVer)) {
    return Promise.resolve();
  } else {
    return Promise.reject(t("camReport.phoneerr"));
  }
}

/**时间选择器确认回调 */
function onOk(value, dateString) {}

/**数组去重 */
function newArrFn(arr) {
  // .new Set方法，返回是一个类数组，需要结合 ...运算符，转成真实数组
  return [...new Set(arr)];
}

/**获取YYYY-MM-DD格式的当前日期，由文心一言生成 */
function getFormattedDate() {
  // 获取当前日期
  const now = new Date();

  // 获取年份（四位数）
  const year = now.getFullYear();

  // 获取月份（加1得到1-12的数值，然后用两位数表示）
  const month = String(now.getMonth() + 1).padStart(2, "0");

  // 获取日期（两位数表示）
  const day = String(now.getDate()).padStart(2, "0");

  // 拼接成字符串
  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
}

/**由于向数据库中传递时间的时候总会少八个小时，所以使用该方法进行时间矫正，由文心一言生成 */
function utcToCST(utcDate) {
  const offsetMilliseconds = 8 * 60 * 60 * 1000; // 8小时毫秒数
  const cstDate = new Date(utcDate.getTime() + offsetMilliseconds);
  return cstDate.toISOString().slice(0, -1) + "+08:00"; // 转换为ISO 8601格式并添加时区偏移量
}

/**产品选择器选择产品回调函数 */
function handleProductChange() {}

const rules = {
  Product: [
    {
      required: true,
      message: t("camReport.productin"),
      trigger: "change",
    },
  ],
  Version: [
    {
      required: true,
      message: t("camReport.versionin"),
      trigger: "change",
    },
  ],
  Phone: [
    {
      required: true,
      validator: validatePhone,
      trigger: "change",
    },
  ],
  Title: [
    {
      required: true,
      message: t("camReport.titlein"),
      trigger: "change",
    },
  ],
  HtmlContent: [
    {
      required: true,
      message: t("camReport.stepin"),
      trigger: "change",
    },
  ],
  /*   BntFile: [
    {
      required: true,
      message: t("camReport.bntin"),
      trigger: "blur",
    },
  ], */
};
</script>

<style scoped>
.content_card {
  width: 80%;
  min-width: 1200px;
  margin: 0px auto;
}

.cardImp {
  margin-right: 10px;
}

.ant-form-item {
  margin-bottom: 0 !important;
}

.primaryAdd {
  margin-right: 10px;
}

.snowy-buttom-left {
  margin-left: 8px;
}

:deep(a) {
  color: #1677ff !important;
}
:deep(a:hover, a:focus) {
  color: #1677ff !important;
}
</style>
